export default {
  name: 'ja',
  data: {
    modal: {
      cancel: 'キャンセル',
      confirm: '確認'
    },
    pagination: {
      prev: '前へ',
      next: '次へ'
    },
    select: {
      empty: 'データなし... \\[ o_x ]/'
    },
    table: {
      empty: 'データなし... \\[ o_x ]/'
    }
  }
}